import { Modal } from 'components';
import { ReviewDetail } from 'components/reviews';
import { useWindowSize } from 'hooks';

export default function ReviewModal({ show, onClose, ...props }) {
  const [, { isMobile }] = useWindowSize();

  return (
    <Modal
      show={show}
      onClose={onClose}
      withActionButtons={false}
      contentClassName="px-0 pt-0 pb-3"
      centered={isMobile}
    >
      <ReviewDetail {...props} variant="big" />
    </Modal>
  );
}
